{
 "_meta": {
  "locale": "pt",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "Agora",
  "people": "Pessoas",
  "cases": "Processos",
  "agenda": "Agenda",
  "reviews": "Revisões",
  "prospects": "Prospeção",
  "insights": "Análises",
  "data": "Dados e segurança",
  "settings": "Definições",
  "lens": "Lupa"
 },
 "common": {
  "save": "Guardar",
  "cancel": "Cancelar",
  "close": "Fechar",
  "search": "Pesquisar",
  "today": "Hoje",
  "tomorrow": "Amanhã",
  "new": "Novo",
  "edit": "Editar",
  "delete": "Eliminar"
 },
 "settings": {
  "title": "Definições",
  "language": "Idioma",
  "region": "Mercado / região",
  "theme": "Aparência"
 },
 "people": {
  "title": "Pessoas",
  "new": "Nova pessoa"
 },
 "today": {
  "agenda_title": "Hoje"
 },
 "lens": {
  "placeholder": "Pesquisar pessoas, prospetos, processos — ou escrever um comando"
 }
}